export const COMPANY_TYPES = {
  PRIVATE_LIMITED: {
    label: 'Private Limited Company',
    requiredFields: ['companyPAN', 'cin']
  },
  PUBLIC_LIMITED: {
    label: 'Public Limited Company',
    requiredFields: ['companyPAN', 'cin']
  },
  LLP: {
    label: 'Limited Liability Partnership',
    requiredFields: ['companyPAN', 'llpin']
  },
  OPC: {
    label: 'One Person Company',
    requiredFields: ['companyPAN', 'cin']
  },
  PARTNERSHIP: {
    label: 'Partnership Firm',
    requiredFields: ['companyPAN', 'partnershipDeed']
  },
  PROPRIETORSHIP: {
    label: 'Proprietorship',
    requiredFields: ['personalPAN']
  },
  HUF: {
    label: 'Hindu Undivided Family',
    requiredFields: ['personalPAN', 'hufDeed']
  },
  TRUST: {
    label: 'Trust',
    requiredFields: ['trustPAN', 'trustDeed']
  },
  SOCIETY: {
    label: 'Society',
    requiredFields: ['societyPAN', 'registrationCertificate']
  }
};

export const ONBOARDING_STEPS = [
  {
    id: 'gstin',
    label: 'GSTIN',
    icon: '📋',
  },
  {
    id: 'basic',
    label: 'Basic Info',
    icon: '📝',
  },
  {
    id: 'company',
    label: 'Company Info',
    icon: '🏢',
  },
  {
    id: 'bank',
    label: 'Bank',
    icon: '🏦',
  },
  {
    id: 'declaration',
    label: 'Declaration',
    icon: '📜',
  },
];

export const INITIAL_FORM_DATA = {
  gstin: '',
  companyName: '',
  panNumber: '',
  address: '',
  city: '',
  state: '',
  country: 'India',
  pincode: '',
  gstinNumber: '',
  organizationEmail: '',
  primaryContactName: '',
  primaryContactPhone: '',
  primaryContactEmail: '',
  businessOwnerName: '',
  ownerContactNumber: '',
  ownerEmail: '',
  isExistingPoloPanPartner: 'No',
  entityType: '',
  companyPAN: '',
  personalPAN: '',
  trustPAN: '',
  societyPAN: '',
  cin: '',
  llpin: '',
  partnershipDeed: '',
  hufDeed: '',
  trustDeed: '',
  registrationCertificate: '',
  incorporationDate: '',
  registrationNumber: '',
  polopanGeneratedInvoice: 'No',
  signature: '',
  needTdsBenefits: 'No',
  accountHolderName: '',
  accountNumber: '',
  ifsc: '',
  bankName: '',
  accountType: '',
  cancelledCheque: '',
  detailsDeclaration: false,
  policiesDeclaration: false
}; 